// Package Imports
import { useTranslate } from '@refinedev/core';
import { Col, Row } from 'antd';
import { useEffect } from 'react';
import { useWatch } from 'antd/es/form/Form';
import QueryBuilder from 'components/queryBuilder/query-builder';

import RadioInput from 'components/radio/RadioInput';
import TextAreaInput from 'components/textarea/textAreaInput';
import { initialValuesQueryBuilder } from 'pages/rules/RulesDummyData';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import usePermission from 'core/utils/usePermission';
import ConfigStyle from 'core/constants/ConfigStyle';
// eslint-disable-next-line import/extensions
import useRulesDropdown from './RulesDropdown';

export const RuleDescription = ({ disabled }) => {
  const t = useTranslate();

  return (
    <Row gutter={16} className="mb-4">
      <Col xs={24} sm={24} lg={24}>
        <TextAreaInput
          label={t('rules.ruleDescription')}
          name="rule_description"
          message={t('rules.messages.ruleDescription')}
          placeholder={t('rules.messages.ruleDescription')}
          rows={4}
          required={false}
          disabled={disabled}
        />
      </Col>
    </Row>
  );
};

export const RuleApplicability = ({
  type,
  form,
  configFields,
  disabled,
  ruleApplicabilityError,
  isSavedClick,
}) => {
  const checkPermission = usePermission();
  const t = useTranslate();
  const { editorOptions, modeOptions } = useRulesDropdown();
  const ruleApplicabilityFormulaEditorType = useWatch(
    'rule_applicability_editor_type',
    {
      form,
      preserve: true,
    }
  );
  console.log(
    ruleApplicabilityFormulaEditorType,
    'ruleApplicabilityFormulaEditorType'
  );
  const hasApplicabilityView = !!checkPermission(
    PrivateRouteConst.RULE_APPLICABILITY_VIEW
  );
  const hasApplicabilityEdit = !!checkPermission(
    PrivateRouteConst.RULE_APPLICABILITY_EDIT
  );
  const ruleApplicabilityFormulaModeType = useWatch(
    'rule_applicability_mode_type',
    {
      form,
      preserve: true,
    }
  );

  useEffect(() => {
    // This will re-render when configFields changes
  }, [configFields]);

  const handleOnQueryChange = (val) => {
    form.setFieldsValue({ rule_expression: val });
  };

  console.log(
    ruleApplicabilityFormulaModeType,
    'ruleApplicabilityFormulaModeType'
  );

  const newruleVersion = useWatch('rule_version', {
    form,
    preserve: true,
  });

  console.log(
    form.getFieldValue('rule_expression')?.query,
    newruleVersion,
    'queryCheckRuleApplicabil'
  );
  if (!hasApplicabilityView) return null;
  return (
    <>
      <div className={type !== 'Show' ? 'block' : 'hidden'}>
        <Row gutter={16} className="">
          <Col xs={24} sm={24} lg={18} className="radio-label">
            <RadioInput
              label={t('rules.selectEditorType')}
              name="rule_applicability_editor_type"
              defaultValue="wizard"
              options={editorOptions}
              disabled={disabled}
              style={{ display: 'none' }}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col sm={24}>
            <span
              style={{
                fontWeight: ConfigStyle.labelfontWeight,
                color: ConfigStyle.labelColor,
              }}
            >
              {t('rules.qbApplyLabel')}
              <span className="a8-error"> *</span>
            </span>
          </Col>
          <Col xs={24} sm={24} lg={18} className="radio-label">
            <RadioInput
              label={t('rules.selectModeType')}
              name="rule_applicability_mode_type"
              defaultValue="single"
              options={modeOptions}
              disabled={disabled || !hasApplicabilityEdit}
            />
          </Col>
        </Row>
      </div>

      <div key={JSON.stringify(newruleVersion)}>
        <Row gutter={16} className="mb-0">
          <Col xs={24} sm={24} lg={24}>
            <QueryBuilder
              label="Apply This Rule When"
              configFields={{
                mode: ruleApplicabilityFormulaModeType,
                columns: configFields,
              }}
              queryValue=""
              setExpression={handleOnQueryChange}
              handleOnQueryChange={handleOnQueryChange}
              expressionValue={
                // eslint-disable-next-line no-nested-ternary
                form.getFieldValue('rule_applicability_mode_type') ===
                  'single' && form.getFieldValue('rule_expression')?.query
                  ? form.getFieldValue('rule_expression')
                  : form.getFieldValue('rule_applicability_mode_type') ===
                        'sql' &&
                      form.getFieldValue('rule_expression')?.caseList?.length >
                        0
                    ? form.getFieldValue('rule_expression')
                    : initialValuesQueryBuilder
              }
              showButtons={
                checkPermission(PrivateRouteConst.SHOW_BUTTON) || false
              }
              showEditor={type !== 'Show' ? hasApplicabilityEdit : false}
              key={JSON.stringify(configFields)} // Ensures re-render on configFields change and newruleversionchange
            />
          </Col>
        </Row>
        {isSavedClick && ruleApplicabilityError ? (
          <p className="a8-error">
            {t('rules.messages.ruleApplicabilityQbError')}
          </p>
        ) : null}
      </div>
    </>
  );
};
